import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import { ShowHideButton } from '@/components/show-hide';
import { Field } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';

import { useToggle } from '@/hooks/use-toggle';

import type { PhoneNumberCreateFormValues } from '@/schemas/phone-number.schema';

import { useFormikError } from '@/lib/error';

export const CreatePhoneNumberForm = () => {
  const { getFieldProps } = useFormikContext<PhoneNumberCreateFormValues>();
  const hasError = useFormikError();

  const { toggle, state } = useToggle();

  return (
    <>
      <div className="space-y-2">
        <Field aria-invalid={hasError('name')}>
          <RequiredLabel htmlFor="name">Name</RequiredLabel>
          <Input
            id="name"
            {...getFieldProps('name')}
            aria-invalid={hasError('name')}
            placeholder="Easy to identify name of the phone number"
            maxLength={30}
          />
          <ErrorField name="name" />
        </Field>
      </div>

      <div className="space-y-2">
        <Field aria-invalid={hasError('phone_number')}>
          <RequiredLabel htmlFor="phone_number">Phone number</RequiredLabel>
          <Input
            id="phone_number"
            {...getFieldProps('phone_number')}
            placeholder="Phone number"
            aria-invalid={hasError('phone_number')}
          />
          <ErrorField name="phone_number" />
        </Field>
      </div>

      <div className="space-y-2">
        <Field aria-invalid={hasError('account_sid')}>
          <RequiredLabel htmlFor="account_sid">Account SID</RequiredLabel>
          <Input
            id="account_sid"
            {...getFieldProps('account_sid')}
            aria-invalid={hasError('account_sid')}
            placeholder="Twilio Account SID"
          />
          <ErrorField name="account_sid" />
        </Field>
      </div>

      <div className="space-y-2">
        <Field aria-invalid={hasError('auth_token')}>
          <RequiredLabel htmlFor="auth_token">Auth Token</RequiredLabel>
          <InputGroup>
            <InputGroupInput
              type={state ? 'text' : 'password'}
              id="auth_token"
              {...getFieldProps('auth_token')}
              placeholder="Twilio Auth Token"
              aria-invalid={hasError('auth_token')}
            />
            <InputGroupAddon align="inline-end">
              <ShowHideButton state={state} toggle={toggle} />
            </InputGroupAddon>
          </InputGroup>
          <ErrorField name="auth_token" />
        </Field>
      </div>
    </>
  );
};
